import TranslationModel from '../../../../../Spirit/Admin/Interfaces/Models/TranslationModel';

export default class UpdateAudioFileCategoryRequest  {
	Id?: number = null;
	Translations: Array<TranslationModel> = null;
	constructor(obj?: Partial<UpdateAudioFileCategoryRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
